/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  canNotBeEmpty: {
    defaultMessage: 'This field cannot be empty',
    id: 'Input.canNotBeEmpty',
  },
  noLongerThan: {
    defaultMessage: 'This field cannot be longer than {maxLength} characters',
    id: 'Input.noLongerThan',
  },
  tooShort: {
    defaultMessage: 'This field cannot be shorter than {minLength} characters',
    id: 'Input.tooShort',
  },
  onlyDigits: {
    defaultMessage: 'The field should only contain digits',
    id: 'Input.onlyDigits',
  },
});
